<template>
    <modal @close="cancelClick" class="edit-modal" hideFooter id="edit-company-address">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Company Address</h3>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Company Address</h3>
                    <div class="md-col-2">
                        <div class="column">
                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Address:</label>
                                <input :class="[{'error': addressValidator.errors['line1']}, 'td-input']"
                                       v-model="update.line1" type="text" placeholder="Address Line 1"
                                       @input="addressValidator.validate('line1');" />
                                <error v-if="addressValidator.errors['line1']" :error="addressValidator.errors['line1']"></error>
                            </div>

                            <div class="my-1">
                                <label class="td-label">City:</label>
                                <input :class="[{'error': addressValidator.errors['city']}, 'td-input']"
                                       v-model="update.city" type="text" placeholder="City" @input="addressValidator.validate('city')" />
                                <error v-if="addressValidator.errors['city']" :error="addressValidator.errors['city']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">State/Province:</label>
                                <select v-model="update.regionCode" id="regionCode" name="regionCode" required
                                        :class="[{'error': addressValidator.errors['regionCode']}, 'td-select']"
                                        @change="addressValidator.validate('regionCode')">
                                    <option value="" disabled selected>Select region</option>
                                    <option v-for="region in selectableRegions" :value="region" :key="region">{{ region }}</option>
                                </select>
                                <error v-if="addressValidator.errors['regionCode']" :error="addressValidator.errors['regionCode']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label">Country:</label>
                                <select v-model="countryCode" id="countryCode" name="countryCode" required
                                        :class="[{'error': addressValidator.errors['countryCode']}, 'td-select']"
                                        @change="changeCountry();addressValidator.validate('countryCode')">
                                    <option value="" disabled selected>Select country</option>
                                    <option value="CA">Canada</option>
                                    <option value="US">United States</option>
                                </select>
                                <error v-if="addressValidator.errors['countryCode']" :error="addressValidator.errors['countryCode']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label">Postal/Zip Code:</label>
                                <input :class="[{'error': addressValidator.errors['postalCode'] || addressValidator.errors['postalCodeFinal']}, 'td-input']"
                                       v-model="update.postalCode" type="text" :placeholder="postalPlaceholder"
                                       @input="addressValidator.validate('postalCode')"
                                       @blur="addressValidator.validate('postalCodeFinal')" />
                                <error v-if="addressValidator.errors['postalCode']" :error="addressValidator.errors['postalCode']"></error>
                                <error v-if="addressValidator.errors['postalCodeFinal']" :error="addressValidator.errors['postalCodeFinal']"></error>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="cancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="saveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditCompanyAddress';
    export default script;
</script>
<style lang="less">
    @import './EditCompanyAddress.less';
</style>